import { render, staticRenderFns } from "./BaseNoPhoto.vue?vue&type=template&id=424b76de&scoped=true&"
import script from "./BaseNoPhoto.vue?vue&type=script&lang=js&"
export * from "./BaseNoPhoto.vue?vue&type=script&lang=js&"
import style0 from "./BaseNoPhoto.vue?vue&type=style&index=0&id=424b76de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424b76de",
  null
  
)

export default component.exports